function m(e) {
  return typeof e != "string" ? !1 : [
    /^[0-9]{0,10000}\.?[0-9]{1,10000}(vmin|vmax|vh|vw|%|ch|ex|em|rem|in|cm|mm|pt|pc|px)$/,
    /^var\(--\D{1,100}\)$/
  ].some((n) => n.test(e));
}
const u = "0px", d = "0.0625rem", $ = "0.125rem", b = "0.25rem", y = "0.5rem", O = "0.75rem", h = "1rem", v = "1.5rem", L = "2rem", C = "3rem", V = "4rem", z = {
  none: u,
  xxs: d,
  xs: $,
  sm: b,
  md: y,
  mdLg: O,
  lg: h,
  lgXl: v,
  xl: L,
  xlXXl: C,
  xxl: V
}, k = 159, D = 319, X = 639, l = 1023, x = 1199, p = 1439, f = 1920, j = {
  xxsmall: `${k}px`,
  xsmall: `${D}px`,
  small: `${X}px`,
  medium: `${l}px`,
  large: `${x}px`,
  xlarge: `${p}px`,
  xxlarge: `${f}px`
};
function g(e) {
  return e.reduce((n, [s, r]) => ({ ...n, [s]: r }), {});
}
const G = (e, n) => {
  var t, a;
  const s = (a = (t = e.space) != null ? t : e.spacing) != null ? a : z, o = g(
    Object.entries(s).map(([S, c]) => [
      S,
      typeof c == "number" ? `${c}px` : c
    ])
  )[n];
  return m(o) ? o : void 0;
};
function A(e, n) {
  return typeof n == "number" && n > 0 ? `${n}px` : m(n) ? n : n !== void 0 ? G(e, n) : void 0;
}
function w({ gutter: e }, n) {
  e === void 0 || typeof e == "number" || typeof e == "string" || console.error(`${n} needs to be a number, CSSLength or SizesOptions`);
}
const F = w, H = (e, n) => {
  var o;
  if (typeof n == "number" || n === void 0)
    return;
  const s = (o = e.sizes) != null ? o : j;
  return g(
    Object.entries(s).map(([i, t]) => [
      i,
      typeof t == "number" ? `${t}px` : t
    ])
  )[n];
}, B = 639, E = [640, 1023], I = [1024, 1199], P = [1200, 1439], q = {
  smallOnly: B,
  mediumOnly: E,
  largeOnly: I,
  xlargeOnly: P,
  medium: l,
  large: x,
  xlarge: p,
  xxlarge: f
}, J = (e = {}) => ({
  ...q,
  ...e
});
export {
  q as breakPoints,
  m as checkIsCSSLength,
  A as getSafeGutter,
  H as getSizeValue,
  G as getSpacingValue,
  J as mergeBreakpoints,
  j as sizes,
  z as spacing,
  F as validateGutter
};
